import './VoteBtn.css';
import checkIcon from '../../../assets/images/checkIcon.svg';
import thumbUpWhite from '../../../assets/images/thumbUpWhite.svg';
import sendBoteIcon from '../../../assets/images/sendVoteIcon.svg';

const VoteBtn = ({vote, onChangeEmail, email, onClickVote, voteBtnState}) => {

  return (
    <div className="container_votes">
      {voteBtnState === "untouched" && (
        <button className="upvote-button" onClick={vote}>
           <img
            style={{ paddingRight: "10px" }}
            src={thumbUpWhite}
            alt="Thumb up icon"
          />{" "}Vote
        </button>
      )}
      {voteBtnState === "clicked" && (
        <div className="input-vote-button-wrapper">
          <input
            type="email"
            className="vote-input"
            placeholder="Email Adress..."
            onChange={(e) => onChangeEmail(e)}
            value={email}
          />
          <button
            className="vote-button"
            onClick={onClickVote}
          >
            <img src={sendBoteIcon} alt="send vote" />
          </button>
        </div>
      )}
      {voteBtnState === "voted" && (
        <button disabled className="final-view-vote-button">
          Success <img src={checkIcon} />
        </button>
      )}
    </div>
  );
};

export default VoteBtn;
